<template>
  <div class="login">
    <el-card>
      <h2>Log Masuk</h2>
      <el-form
        class="login-form"
        :model="model"
        :rules="rules"
        ref="form"
        @submit.native.prevent="login"
      >
        <el-form-item prop="username">
          <el-input v-model="model.username" placeholder="Web ID" prefix-icon="fas fa-user">
             <template slot="prepend"><font-awesome-icon :icon="['fa', 'user']" size="lg"></font-awesome-icon></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="model.password"
            placeholder="Password"
            type="password"
            prefix-icon="fas fa-lock"
          >
             <template slot="prepend"><font-awesome-icon :icon="['fa', 'key']" size="lg"></font-awesome-icon></template>
            </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loading"
            class="login-button"
            type="primary"
            native-type="submit"
            block
          >Login</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      model: {
        username: "",
        password: ""
      },
      loading: false,
      rules: {
        username: [
          {
            required: true,
            message: "WebID diperlukan",
            trigger: "blur"
          }
        ],
        password: [
          { required: true, message: "Katalaluan diperlukan", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    simulateLogin() {
      return new Promise(resolve => {
        setTimeout(resolve, 800);
      });
    },
    async login() {
      let valid = await this.$refs.form.validate();
      if (!valid) {
        return;
      }
      this.loading = true;

      this.$store.dispatch('Login', this.model)
      .then(() => this.$router.push('/'))
      // eslint-disable-next-line no-unused-vars
      .catch( err => {
        this.$message.error("Kesalahan pada username atau password")
        this.loading = false;
      })
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-button {
  width: 100%;
  margin-top: 40px;
}
.login-form {
  width: 290px;
}
.forgot-password {
  margin-top: 10px;
}
</style>